import { QRMenuSettings } from './QRMenuSettings.model';

export class AppSettings {
  QRMenu: QRMenuSettings;
  POS?: Record<string, any>;
  [key: string]: any;

  constructor(data?: Partial<AppSettings> | any) {
    const qrData = data?.QRMenu ?? data?.qrMenu;
    this.QRMenu = new QRMenuSettings(qrData);
    if (data?.POS ?? data?.pos) {
      this.POS = data?.POS ?? data?.pos;
    }
    if (data) {
      Object.assign(this, data);
      this.QRMenu = new QRMenuSettings(qrData);
    }
  }
}
